import { StarIcon } from "@chakra-ui/icons";
import { Box, Flex, FlexProps, Image, Text, useBreakpointValue } from "@chakra-ui/react";

type RatingProps = {
  number?: boolean;
  generalGrade: any;
  reviewCount?: any;
};

export function Rating({ generalGrade, reviewCount, number }: RatingProps | null) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  const TotalValue = 5;
  const TotalPercent = 100;
  const pluralOrSingle = generalGrade === 1 ? "avaliação" : "avaliações";
  const Percent = 100 - (TotalPercent * generalGrade) / TotalValue;

  return reviewCount != "0" ? (
    <Box display="flex" alignItems="center" mt="5px">
      {number && (
        <Text mr={"5px"} mb={"-3px"}>
          {generalGrade}
        </Text>
      )}

      <Image
        maxW={"80px"}
        src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/new-bg-starts.png"}
        bgImage={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/bg-calc-sarts.png"}
        bgRepeat={"no-repeat"}
        bgPos={`-${Percent}px 0px`}
      />

      {/* {Array(5)
        .fill("")
        .map((_, i) => (
          <StarIcon key={i} color={i < generalGrade ? "ll-gray.300" : "red"} mx={"1px"} />
        ))} */}

      <Flex
        mt="3px"
        as="span"
        ml={["1", "2"]}
        color="ll-gray.300"
        letterSpacing={"-1px"}
        fontSize={"text1"}
      >
        {isWideVersion ? (
          <>
            {reviewCount} Avaliaç{reviewCount == "1" ? "ão" : "ões"}
          </>
        ) : (
          `(${reviewCount})`
        )}
      </Flex>
    </Box>
  ) : (
    <Box display="flex" alignItems="center" h={"25px"} />
  );
}

export function RatingCarosel({ Rating, Reviews, ...props }: ProductRatingProps) {
  const TotalValue = 5;
  const TotalPercent = 100;
  const pluralOrSingle = Reviews === 1 ? "avaliação" : "avaliações";

  const Percent = 100 - (TotalPercent * Rating) / TotalValue;
  if (!Rating || Reviews <= 0) {
    return null;
  } else {
    return (
      <Flex
        mt="3px"
        as="span"
        {...props}
        alignItems={"center"}
        textStyle="NotoBold"
        color="gray.600"
        gap={"5px"}
        fontSize={["12px", "12px"]}
        _hover={{ opacity: "80%" }}
      >
        <Text>{Rating}</Text>
        <Image
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/new-bg-starts.png"}
          bgImage={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/bg-calc-sarts.png"}
          bgRepeat={"no-repeat"}
          bgPos={`-${Percent}px 0px`}
          mt={"-5px"}
        />
        {Reviews && (
          <Text>
            {Reviews} {pluralOrSingle}
          </Text>
        )}
      </Flex>
    );
  }
}

export function IndividualRating({ generalGrade }: RatingProps) {
  return (
    <Box display="flex" alignItems="center">
      {Array(5)
        .fill("")
        .map((_, i) => (
          <StarIcon key={i} color={i < generalGrade ? "yellow.400" : "gray.300"} />
        ))}
      <Box as="span" ml="2" color="#58585A" fontSize="14px">
        {generalGrade?.toFixed()}
      </Box>
    </Box>
  );
}

export function ProductSearchRating({ Rating, Reviews, ...props }) {
  const IsWide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });
  const TotalValue = 5;
  const TotalPercent = 100;
  const Percent = 100 - (TotalPercent * Rating) / TotalValue;

  return Reviews > 0 ? (
    <>
      <Flex
        {...props}
        mt={IsWide ? "10px" : "0px"}
        alignItems={"center"}
        gap={"5px"}
        marginTop={"-2px"}
      >
        <Image
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/new-bg-starts.png"}
          bgImage={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/bg-calc-sarts.png"}
          maxW={"80px"}
          bgRepeat={"no-repeat"}
          bgPos={`-${Percent}px 0px`}
        />
        <Text color={"ll-gray.300"} fontWeight={"400"} fontSize={IsWide ? "14px" : "12px"}>
          {parseFloat(Rating)}
        </Text>
      </Flex>
    </>
  ) : null;
}

interface ProductRatingProps extends FlexProps {
  Rating: number;
  Reviews?: number;
}

export function ProductRating({ Rating, Reviews, ...props }: ProductRatingProps) {
  const TotalValue = 5;
  const TotalPercent = 100;
  const pluralOrSingle = Reviews === 1 ? "avaliação" : "avaliações";
  const Percent = 100 - (TotalPercent * Rating) / TotalValue;
  if (!Rating || Reviews <= 0) {
    return null;
  } else {
    return (
      <Flex
        {...props}
        alignItems={"center"}
        color={"ll-gray.300"}
        gap={"5px"}
        fontSize={"16px"}
        _hover={{ opacity: "0.5" }}
      >
        <Text>{Rating}</Text>
        <Image
          maxW={"90px"}
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/new-bg-starts.png"}
          // bgImage={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/bgstar.png"}
          bgImage={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/bg-calc-sarts.png"}
          bgRepeat={"no-repeat"}
          bgPos={`-${Percent}px 0px`}
          mt={"-5px"}
        />
        {Reviews && (
          <Text>
            {Reviews} {pluralOrSingle}
          </Text>
        )}
      </Flex>
    );
  }
}

interface ProductCategoryRatingProps extends FlexProps {
  Rating: number;
  isExpanded?: boolean;
}

export function ProductCategoryRating({
  Rating,
  isExpanded,
  ...props
}: ProductCategoryRatingProps) {
  const TotalValue = 5;
  const TotalPercent = 100;
  const Percent = 100 - (TotalPercent * Rating) / TotalValue;
  if (!Rating) {
    return null;
  } else {
    return (
      <Flex
        {...props}
        textStyle={"NotoBold"}
        fontSize={"20px"}
        alignItems={"center"}
        textColor={"#3165C4"}
        gap={"5px"}
      >
        <Image
          maxW={"100px"}
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/new-bg-starts.png"}
          bgImage={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/bg-calc-sarts.png"}
          bgRepeat={"no-repeat"}
          bgPos={`-${Percent}px 0px`}
        />
        <Text ml={["10px", "0"]} fontSize={"h3"} fontWeight={"600"} color={"ll-blue.main"}>
          {Rating.toFixed(1)}
        </Text>
      </Flex>
    );
  }
}
